import type { ActionFlowNode, AliyunMessageActionConfig, AliyunMessageActionConfigure, FlowNodeResultADT } from '@lighthouse/shared'
import { generateVariableValue, resolveVariable } from '@lighthouse/shared'
import { safeToString } from '@lighthouse/tools'
import { t } from 'i18next'
import { find } from 'rambda'

import * as srv from '@/services'

import type { ExecuteActionParams } from '../type'

export const handleAliyunMessageStream = async (
    node: ActionFlowNode<AliyunMessageActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    return await handleAliyunMessage(config, params)
}

export const handleAliyunMessage = async (config: AliyunMessageActionConfig, params: ExecuteActionParams) => {
    const { mobileList, signatureId, templateId, values } = config
    const mobileListValue = resolveVariable(mobileList, params) ?? ''
    const mobileListString = safeToString(mobileListValue)
    const valuesListValue = values.map(value => ({
        variableName: value.variableName,
        value: safeToString(
            generateVariableValue({
                innerType: 'TEXT',
                jsonContent: value.value,
                extraParams: params,
                options: { format: true, useFileUrl: true }
            })
        )
    }))

    const isSuccess = await srv.activeAliyunMessageAction({
        mobileList: mobileListString,
        signatureId,
        templateId,
        values: valuesListValue
    })

    if (!isSuccess) {
        throw new Error(t('sendAliyunMsgError'))
    }

    return { success: true, type: 'record' } satisfies FlowNodeResultADT
}
